var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalAlert',{attrs:{"text-body":_vm.modalTextBody,"open":_vm.modalShow,"type":_vm.modalType,"showModalClose":false,"showCustomButtons":false},on:{"close":_vm.clearModalAlertData}})
}
var staticRenderFns = []

export { render, staticRenderFns }